import React, { Component } from "react";
import { Link, animateScroll as scroll } from "react-scroll";

const scrollToTop = () => {
    scroll.scrollToTop();
  };

export const Navbar = () => {
  return (
    <>
		<div className="navbardiv"></div>

      <nav className="navbar" id="navbar">
        <div className="nav-content">
          <ul className="nav-items">
            <li className="nav-item">
              <Link
                activeClass="active"
                to="Contact"
                spy={true}
                smooth={true}
                offset={-50}
                duration={600}
              >
                Contact
              </Link>
            </li>
            <li className="nav-item">
              <Link
                activeClass="active"
                to="Pinterest"
                spy={true}
                smooth={true}
                offset={-50}
                duration={600}
              >
                Pinterest
              </Link>
            </li>
            
            <li className="nav-item">
              <Link
                activeClass="active"
                to="About"
                spy={true}
                smooth={true}
                offset={-50}
                duration={600}
              >
                About
              </Link>
            </li>
            <li className="nav-item">
              <Link
                activeClass="active"
                to="Home"
                spy={true}
                smooth={true}
                offset={-50}
                duration={600}
              >
                Home
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
